<div >
  <div class="row " *ngIf="!Addgrpser&&!updategrpser">
    <div class="col-12 mb-2">
      <h4 class="mb-0 font-header-1 mb-2" style="font-weight: 700;">Group Payor Service</h4>
    </div>
  </div>
  <div *ngIf="global.globalAgencyId==null || global.globalAgencyId==undefined ||global.globalAgencyId=='00000000-0000-0000-0000-000000000000' || this.global.globalAgencyId == '' ">
    <div class="row mt-4 ">
      <div class="col ">
        <div widget class="card border-0 box-shadow">
          <div class="card-body  widget-body pt-2">
            <div class="text-center text-danger">
              <label class="font-red animate-charcter"><i class="fa fa-info-circle fa-lg"></i>&nbsp;Select agency to view
                details</label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row mt-4"
    *ngIf="!Addgrpser&&!updategrpser && global.globalAgencyId!=null && global.globalAgencyId!='' && global.globalAgencyId!=undefined &&  global.globalAgencyId!='00000000-0000-0000-0000-000000000000'">
    <div class="col-12 mt-3 ps-0 ">
      <div widget class="card border-0 box-shadow">
        <div class="card-body">
          <div class="row mt-2 mb-2 d-flex jutify-content-center align-items-center">
                 <div class="col-lg-12 col-md-12 col-sm-12">
              
       
          <div class="row mt-2">
            <div class="col-lg-3">
              <div class="col-lg-12">
                <label style="font-weight:bold">Status</label>
              </div>
              <div class="col-lg-12">
                <ng-select  [clearable]="true" [searchable]="true"  [items]="filterstatusList"  
                bindLabel="lovName"
               bindValue="id"  [(ngModel)]="FilterStatus"  id="GPStatus"  (ngModelChange)="getPayorTotalItem()">
             </ng-select>
              </div>
            </div>
            <div class="col-lg-3">
              <div class="col-lg-12">
                <label style="font-weight:bold">Filter By</label>
              </div>
              <div class="col-lg-12">
                <select [(ngModel)]="filterSelect" class="form-control " id="GPFilter_By"  (change)="selected_filter(filterSelect)"
                  [disabled]="global.globalAgencyId == '00000000-0000-0000-0000-000000000000'">
                  <option value="groupName">Group</option>
                  <option value="payorName">Payor</option>
                  <option value="serviceName">Service</option>
                  <option value="name">Facility Name</option>
                  <option value="facilityID">Facility</option>
                  <option value="billingUnit">Billing Unit</option>
                </select>
              </div>
            </div>
            <div class="col-lg-3">
              <div class="col-lg-12">
                <label
                  [hidden]="filterSelect=='payorName'||filterSelect=='serviceName'||filterSelect=='billingUnit'||filterSelect=='name'||filterSelect=='facilityID'"
                  style="font-weight:bold">Group</label>
                <label *ngIf="filterSelect=='payorName'" style="font-weight:bold">Payor</label>
                <label *ngIf="filterSelect=='serviceName'" style="font-weight:bold">Service</label>
                <label *ngIf="filterSelect=='billingUnit'" style="font-weight:bold">BillingUnit</label>
                <label *ngIf="filterSelect=='name'" style="font-weight:bold">Facilityname</label>
                <label *ngIf="filterSelect=='facilityID'" style="font-weight:bold">FacilityId</label>
              </div>
              <div class="col-lg-12">
                <!-- group -->
                <div
                  [hidden]="filterSelect=='payorName'||filterSelect=='serviceName'||filterSelect=='billingUnit'||filterSelect=='name'||filterSelect=='facilityID'">
                  <select [(ngModel)]="Filter_Group" class="form-control" id="GPFilter_Group">
                    <option></option>
                    <option *ngFor="let i of groupLst" [disabled]="global.globalAgencyId == '00000000-0000-0000-0000-000000000000'">{{i.lovName}}</option>
                  </select>
  
                </div>
                <!-- Payor -->
                <div *ngIf="filterSelect=='payorName'">
                  <select [(ngModel)]="Filter_Payor" id="GPFilter_Payor" [disabled]="global.globalAgencyId == '00000000-0000-0000-0000-000000000000'" class="form-control ">
                    <option></option>
                    <option *ngFor="let i of AllPayerLst">{{i.Value}}</option>
                  </select>
                </div>
                <!-- serviceName -->
                <div *ngIf="filterSelect=='serviceName'">
                  <ng-select [(ngModel)]="filter_service" id="GPfilter_service" [searchable]="true" bindLabel="masterservice" [clearable]="true"
                    [items]="Allservice" [disabled]="global.globalAgencyId == '00000000-0000-0000-0000-000000000000'" bindValue="id" groupBy="type">
                    <ng-template ng-optgroup-tmp let-item="item">
                      {{item.type}}
                    </ng-template>
                  </ng-select>
                </div>
                <!-- billingUnit -->
                <div *ngIf="filterSelect=='billingUnit'">
                  <select [(ngModel)]="filter_billingUnitLid" [disabled]="global.globalAgencyId == '00000000-0000-0000-0000-000000000000'"
                    class="form-control "  id="GPfilterbillingUnit">
                    <option></option>
                    <option *ngFor="let i of billingUnit">{{i.lovName}}</option>
                  </select>
                </div>
                <!--Facility Name -->
                <div *ngIf="filterSelect=='name'">
                  <input type="text" class="form-control " [disabled]="global.globalAgencyId == '00000000-0000-0000-0000-000000000000'"
                    [(ngModel)]="filter_name" id="GPfilter_name">
                </div>
                <!--Facility Id  -->
                <div *ngIf="filterSelect=='facilityID'">
                  <input type="text" class="form-control " [disabled]="global.globalAgencyId == '00000000-0000-0000-0000-000000000000'"
                    [(ngModel)]="filter_FacilityId" id="GPfacilityID">
                </div>
              </div>
            </div>
            <!-- Apply Group -->
            <div class="col-lg-3 "
              [hidden]="filterSelect=='payorName'||filterSelect=='serviceName'||filterSelect=='billingUnit'||filterSelect=='name'||filterSelect=='facilityID'">
              <div class="col-lg-12 mt-2">
                <label></label>
              </div>
              <div class="col-lg-12">
                <button type="button" class="btn blue-btn btn-sm  ml-2" [disabled]="global.globalAgencyId == '00000000-0000-0000-0000-000000000000'"
                  (click)="search(Filter_Group)" id="GPGroupApply">
                  Apply
                </button>
              </div>
            </div>
            <!-- Apply Payor -->
            <div class="col-lg-3 " *ngIf="filterSelect=='payorName'">
              <div class="col-lg-12 mt-2">
                <label></label>
              </div>
              <div class="col-lg-12">
                <button type="button" class="btn blue-btn btn-sm  ml-2" [disabled]="global.globalAgencyId == '00000000-0000-0000-0000-000000000000'"
                  (click)="search(Filter_Payor)" id="GPPayorApply">
                  Apply
                </button>
              </div>
            </div>
            <!-- Apply Service -->
            <div class="col-lg-3 " *ngIf="filterSelect=='serviceName'">
              <div class="col-lg-12 mt-2">
                <label></label>
              </div>
              <div class="col-lg-12">
                <button type="button" class="btn blue-btn btn-sm  ml-2" [disabled]="global.globalAgencyId == '00000000-0000-0000-0000-000000000000'"
                  (click)="search(filter_service)" id="GPServiceApply">
                  Apply
                </button>
              </div>
            </div>
            <!-- Apply billingUnit -->
            <div class="col-lg-3 " *ngIf="filterSelect=='billingUnit'">
              <div class="col-lg-12 mt-2">
                <label></label>
              </div>
              <div class="col-lg-12">
                <button type="button" class="btn blue-btn btn-sm  ml-2" [disabled]="global.globalAgencyId == '00000000-0000-0000-0000-000000000000'"
                  (click)="search(filter_billingUnitLid)"  id="GPbillingUnitApply">
                  Apply
                </button>
              </div>
            </div>
            <!-- Apply Facility Name -->
            <div class="col-lg-3 " *ngIf="filterSelect=='name'">
              <div class="col-lg-12 mt-2">
                <label></label>
              </div>
              <div class="col-lg-12">
                <button type="button" class="btn blue-btn btn-sm  ml-2" [disabled]="global.globalAgencyId == '00000000-0000-0000-0000-000000000000'"
                  (click)="search(filter_name)" id="GPFacilityNameApply">
                  Apply
                </button>
              </div>
            </div>
            <!-- Apply Facility ID -->
            <div class="col-lg-3 " *ngIf="filterSelect=='facilityID'">
              <div class="col-lg-12 mt-2">
                <label></label>
              </div>
              <div class="col-lg-12">
                <button type="button" [disabled]="global.globalAgencyId == '00000000-0000-0000-0000-000000000000'" class="btn blue-btn btn-sm ml-2"
                  (click)="search(filter_FacilityId)" id="GPFacilityIDApply">
                  Apply
                </button>
              </div>
            </div>
          </div>
          <div class="row  mb-2 mt-2  pl-3 pr-3">
            <div class="col-lg-8">
              <button type="button" class="btn blue-btn btn-sm" data-bs-toggle="modal" data-bs-target="#modal"
                [disabled]="global.globalAgencyId == '00000000-0000-0000-0000-000000000000'" *ngIf="fp.grouppayorservicecreate"
                id="AddGpButton"
                (click)="GrpCreateupdate('new','')">Add
                Group Payor Service</button>&nbsp;&nbsp;
                <button type="button" class="btn blue-btn btn-sm" data-bs-toggle="modal" data-bs-target="#UpdateServicerate"
                [disabled]="global.globalAgencyId == '00000000-0000-0000-0000-000000000000'" 
                (click)="clearUpdaterate()" id="GpUpdateRatesinBulk">
                Update Rates in Bulk</button>&nbsp;&nbsp;
  
            </div>
            <div class="col-lg-4 col-md-6 col-sm-6 col-xs-12 ">
              <button type="button" [disabled]="global.globalAgencyId == '00000000-0000-0000-0000-000000000000'" style="float:right"
                class="btn blue-btn btn-sm" (click)="Refresh()">
                <i class="fa fa-repeat"> </i>Refresh
              </button>
            </div>
          </div>
          <div class="row pl-3 pr-3">
            <div class="col-lg-12 ">
              <ejs-grid #grid [dataSource]='data | async' [allowResizing]='true' [allowSorting]='true'
                *ngIf="global.globalAgencyId!='00000000-0000-0000-0000-000000000000'" [allowPaging]='true' [pageSettings]='initialPage'
                [filterSettings]='filterSettings' [allowFiltering]='true' (actionBegin)="onActionComplete($event)"
                [showColumnChooser]='true' (dataStateChange)='dataStateChange($event)' (resizeStop)="onResize($event)">
                <e-columns>
                  <e-column minWidth=100 headerText="Actions" [showInColumnChooser]='false' uid="Actions">
                    <ng-template #template let-data>
                      <button class="btn btn-edit-table" *ngIf="fp.grouppayorserviceupdate"
                        (click)="GrpCreateupdate('edit',data);selectgrpdetails(data)"><i class="fa fa-edit"></i></button>&nbsp;
                      <button class="btn btn-delete-table" data-bs-toggle="modal" data-bs-target="#deletemodal"
                        *ngIf="fp.grouppayorservicedelete" (click)="selectgrpdetails(data)"><i
                          class="fa fa-trash"></i></button>
                    </ng-template>
                  </e-column>
                  <e-column minWidth=100 field="groupName" headerText="Group">
                    <ng-template #filterTemplate let-data>
                      <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                    </ng-template>
                  </e-column>
                  <e-column minWidth=100 field="payorName" headerText="Payor">
                    <ng-template #filterTemplate let-data>
                      <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                    </ng-template>
                  </e-column>
                  <e-column minWidth=100 field="serviceName" headerText="Service">
                    <ng-template #filterTemplate let-data>
                      <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                    </ng-template>
                  </e-column>
                  <e-column minWidth=100 field="netRate" headerText="Net Rate" type="string">
                    <ng-template #filterTemplate let-data>
                      <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                    </ng-template>
                  </e-column>
                  <e-column minWidth=100 field="serviceLoc" headerText="Service Location">
                    <ng-template #filterTemplate let-data>
                      <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                    </ng-template>
                  </e-column>
                  <e-column minWidth=100 field="name" headerText="Facility Name" type="string">
                    <ng-template #filterTemplate let-data>
                      <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                    </ng-template>
                  </e-column>
                  <e-column minWidth=100 field="address1" headerText="Facility Address1" type="string">
                    <ng-template #filterTemplate let-data>
                      <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                    </ng-template>
                  </e-column>
                  <e-column minWidth=100 field="facilityID" headerText="Facility ID" type="string">
                    <ng-template #filterTemplate let-data>
                      <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                    </ng-template>
                  </e-column>
                  <e-column minWidth=100 field="billingUnit" headerText="Billing Unit">
                    <ng-template #filterTemplate let-data>
                      <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                    </ng-template>
                  </e-column>
  
                  <e-column width="50" [showInColumnChooser]='false'>
                    <ng-template #headerTemplate let-data>
                      <div class="d-none d-lg-block">
                        <span id='show' (click)='show()'><i class="fa fa-cog fa-lg" aria-hidden="true"> </i></span>
                      </div>
                    </ng-template>
                  </e-column>
                </e-columns>
              </ejs-grid>
            </div>
          </div>
          <div *ngIf="GroupPayorServiceDataList.length == 0 &&  global.globalAgencyId!='00000000-0000-0000-0000-000000000000'" class="text-center"
            style="color:red">
            <p>No data available</p>
          </div>
        </div>
        </div>
      </div>
      </div>
    </div>
  </div>
  <!-- Create and Update Group Payer Service -->
  <div *ngIf="updategrpser==true||Addgrpser==true">
    <div class="row mb-2">
      <div class="col pl-0">
        <div widget class="card border-0 box-shadow">
          <div class="card-header transparent  text-muted">
            <div class="row">
              <div class="col-lg-7 col-md-6 col-sm-6">
                <h4 class="mb-0 font-header">Group Payor Service</h4>
              </div>
              <div class="col-lg-4 col-md-6 col-sm-6 mt-2">
                <button *ngIf="updategrpser" class="btn blue-btn btn-sm" [disabled]="!groupPayerForm.valid ||isSaveorUpdateBoolean"
                  (click)="SaveOrUpdateGroupPayorService()" id="CreateGpUpdate">Update & Close</button>
                <button *ngIf="Addgrpser" class="btn blue-btn btn-sm" [disabled]="!groupPayerForm.valid ||isSaveorUpdateBoolean"
                  (click)="SaveOrUpdateGroupPayorService()"  id="CreateGpSave">Save & Close</button>
                &nbsp;&nbsp;&nbsp;
                <button class="btn blue-btn btn-sm" id="openBtn" (click)="cancel()" >
                  Close
                </button>
              </div>
            </div>
          </div>
          <div class="card-body  widget-body pt-2">
            <div class="row alert ml-3 mr-3 alert-warning" *ngIf="showErrorAlert==true">
              <strong>{{error}}</strong>
            </div>
            <form [formGroup]="groupPayerForm">
              <div class="row pl-4">
                <div class="col-lg-12">
                  <div class="row hr-line">
                    <div class="col-lg-6 br-line">
                      <div class="row">
                        <label class="font-header">General
                          Requirements</label>
                      </div>
                      <hr />
                      <div class="row mt-2">
                        <div class="col left-label">
                          <label class="label-bold">Status <sup class="super-script">&nbsp;*</sup></label>
                        </div>
                        <div class="col-md-9">
                          <!-- <select class="form-control " [(ngModel)]="GroupPayorService.statusLid" formControlName="status" 
                          id="CreateGpStatus">
                         <option value="Active">Active</option>
                          <option value="InActive">InActive</option>
                        </select> -->
                        <ng-select  [clearable]="true" [searchable]="true"  [items]="statusList"  
                        bindLabel="lovName" (ngModelChange)="checkpopup('Status')"
                       bindValue="id"  [(ngModel)]="GroupPayorService.statusLid" formControlName="status"   id="CreateGpStatus" >
                     </ng-select>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col left-label">
                          <label class="label-bold">Group <sup class="super-script">&nbsp;*</sup></label>
                        </div>
                        <div class="col-md-9">
                          <select [(ngModel)]="GroupPayorService.groupId"  id="CreateGpGroup"
                            (ngModelChange)="groupchange(GroupPayorService.groupId,true);checkpopup('Group');"
                            class="form-control" [ngModelOptions]="{standalone: true}">
                            <option></option>
                            <option [value]="i.id" *ngFor="let i of groupLst">{{i.lovName}}</option>
                          </select>
                          <span class="help-block text-danger text-center"
                            *ngIf="!groupPayerForm.get('groupId').valid && groupPayerForm.get('groupId').touched ">
                            <p>Please Enter GroupName</p>
                          </span>
                        </div>
                      </div>
                      <div class="row mt-2">
                        <div class="col left-label">
                          <label class="label-bold">Payor<sup class="super-script">&nbsp;*</sup></label>
                        </div>
                        <div class="col-md-9 ">
  
                          <select class="form-control" formControlName="groupPayorId" id="CreateGpPayor"
                            [(ngModel)]="GroupPayorService.groupPayorId" (ngModelChange)="checkpopup('Payor')">
                            <option></option>
                            <option [value]=i.value *ngFor="let i of payerLst">{{i.label}}</option>
                          </select>
  
                          <span class="help-block text-danger text-center"
                            *ngIf="!groupPayerForm.get('groupPayorId').valid && groupPayerForm.get('groupPayorId').touched ">
                            <p>Please Enter Payor Name</p>
                          </span>
                        </div>
                      </div>
  
                      <div class="row mt-2">
                        <div class="col left-label">
                          <label class="label-bold">Service<sup class="super-script">&nbsp;*</sup></label>
                        </div>
                        <div class="col-md-9 ">
  
                          <ng-select [(ngModel)]="MasterserviceId" [searchable]="true" [clearable]="true"
                            [items]="Allservice" class="tdropdown" bindLabel="masterservice" id="CreateGpService"
                            formControlName="masterServiceId" bindValue="id"
                            (change)="serviceChange(MasterserviceId);checkpopup('Service')" groupBy="type">
                            <ng-template ng-optgroup-tmp let-item="item">
                              {{item.type}}
                            </ng-template>
                          </ng-select>
                          <span class="help-block text-danger text-center"
                            *ngIf="!groupPayerForm.get('masterServiceId').valid && groupPayerForm.get('masterServiceId').touched ">
                            <p>Please Enter Service Name</p>
                          </span>
                        </div>
                      </div>
                      <div class="row mt-2">
                        <div class="col left-label">
                          <label class="label-bold">Description</label>
                        </div>
                        <div class="col-md-9 ">
                          <input type="text" class="form-control" disabled
                            [(ngModel)]="GroupPayorService.serviceDescription" (ngModelChange)="checkpopup('Description')"
                            formControlName="serviceDescription"  id="CreateGpServiceDescription">
                        </div>
                      </div>
                      <div class="row mt-2">
                        <div class="col left-label">
                          <label class="label-bold">BillingUnit<sup class="super-script">&nbsp;*</sup></label>
                        </div>
                        <div class="col-md-9 ">
  
                          <select class="form-control" formControlName="billingUnitLid"
                            [(ngModel)]="GroupPayorService.billingUnitLid" id="CreateGpBillingUnit" (ngModelChange)="checkpopup('billingUnit')">
                            <option></option>
  
                            <option [value]="i.id" *ngFor="let i of billingUnit">{{i.lovName}}</option>
                          </select>
                          <span class="help-block text-danger text-center"
                            *ngIf="!groupPayerForm.get('billingUnitLid').valid && groupPayerForm.get('billingUnitLid').touched ">
                            <p>Please Enter Billing Unit</p>
                          </span>
                        </div>
                      </div>
                      <div class="row mt-2">
                        <div class="col left-label">
                          <label class="label-bold">Net Rate<sup class="super-script">&nbsp;*</sup></label>
                        </div>
                        <div class="col-md-9 ">
                          <input type="number" class="form-control" [(ngModel)]="GroupPayorService.netRate"
                            formControlName="netRate" (ngModelChange)="checkpopup('netRate')" id="CreateGpNetRate">
                          <span class="help-block text-danger text-center"
                            *ngIf="!groupPayerForm.get('netRate').valid && groupPayerForm.get('netRate').touched ">
                            <p>Please Enter Net Rate</p>
                          </span>
                        </div>
                      </div>
                      <div class="row mt-2">
                        <div class="col left-label">
                          <label class="label-bold">U/C Rate<sup class="super-script">&nbsp;*</sup></label>
                        </div>
                        <div class="col-md-9 ">
                          <input type="number" class="form-control" [(ngModel)]="GroupPayorService.unitrate"
                            formControlName="unitrate" (ngModelChange)="checkpopup('unitrate')" id="CreateGpUcRate">
  
                          <span class="help-block text-danger text-center"
                            *ngIf="!groupPayerForm.get('unitrate').valid && groupPayerForm.get('unitrate').touched ">
                            <p>Please Enter Unit Rate</p>
                          </span>
                        </div>
                      </div>
                      <div class="row mt-2">
                        <div class="col">
                          <label class="font-header">For Medicare,rates are PER
                            VISIT no matter what Billing Unit is listed</label>
                        </div>
  
                      </div>
                      <div class="row">
  
                      </div>
                      <div class="row mt-2">
                        <div class="col left-label">
                          <label class="label-bold">HCPC Code</label>
                        </div>
                        <div class="col">
                          <input type="text" class="form-control" formControlName="hCPCCode" id="CreateGpHCPCCode"
                            [(ngModel)]="GroupPayorService.hcpcCode" (ngModelChange)="checkpopup('hcpcCode')">
                        </div>
                        <div class="col">
                          <label class="font-header">Payor Tab Data</label>
                        </div>
                      </div>
                      <div class="row mt-2">
                        <div class="col">
                          <input type="checkbox" class="ipt-checkbox" id="billind" formControlName="billIndividually"
                            [(ngModel)]="GroupPayorService.billIndividually" id="CreateGpBillIndividually"
                            (ngModelChange)="checkpopup('billIndividually')">&nbsp;
                          <label for="billind" class="label-bold">Bill Individually</label>
                        </div>
                      </div>
  
                      <div class="row mt-2">
                        <div class="col left-label">
                          <label class="label-bold">Rev Code</label>
                        </div>
                        <div class="col-md-5 ">
                          <input type="text" class="form-control" [(ngModel)]="GroupPayorService.revCode"
                          id="CreateGpRevCode"
                            formControlName="revCode" (ngModelChange)="checkpopup('revCode')">
                        </div>
                        <div class="col">
                          <label class="font-header">Institutional Claims
                            Only</label>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-6 ">
                      <div class="row ">
                        <label class="font-header ml-1">Rendering Provider ID
                          Requirements<sup class="super-script">&nbsp;*</sup></label>
                      </div>
                      <hr />
                      <div class="row">
                        <div class="col render-right br-line">
                          <ng-container *ngFor="let val of providerList">
                            <div class="row ml-0">
                              <input type="radio"   id="CreateGpproviderList"  [value]="val.id" [(ngModel)]="GroupPayorService.providerLid"
                                formControlName="providerLid" class="mt-2 ml-0 mb-2 col-lg-1"
                                (ngModelChange)="checkpopup('providerLid');">
                              &nbsp;<label class="label-bold col-lg-10">{{val.lovName}}</label>
                            </div>
                          </ng-container>
  
                        </div>
                        <div class="col">
  
                          <div class="row ml-0">

                            <label class="label-bold col-md-4 col-lg-3 col-sm-6 pl-0">G2 ID</label>
                            <input type="text" [(ngModel)]="GroupPayorService.g2id" formControlName="g2id"
                            id="CreateGpG2ID" 
                              class="form-control col-lg-8" (ngModelChange)="checkpopup('g2id')">
                          </div>
                          <div class="row  ml-0">
                            <label class="label-bold col-md-4 col-sm-6 pl-0">"None" or NPI</label>
                            <input type="text" formControlName="nPI"  id="CreateGpNoneorNPI"  [(ngModel)]="GroupPayorService.npi"
                              class="form-control col-lg-4" (ngModelChange)="checkpopup('npi')">
                          </div>
                          <div class="row  ml-0">
                            <label class="label-bold col-md-4 col-sm-6  pl-0">Comp Name</label>
                            <input type="text" formControlName="companyName"  id="CreateGpCompName"  [(ngModel)]="GroupPayorService.companyName"
                              class="form-control col-lg-4" (ngModelChange)="checkpopup('companyName')">
                          </div>
                          <div class="row  ml-0">
                            <label class="label-bold col-md-4 col-sm-6  pl-0">Taxonomy Code</label>
                            <input type="text" formControlName="taxonomyCode" id="CreateGpTaxCode"  [(ngModel)]="GroupPayorService.taxonomyCode"
                              class="form-control col-lg-4" (ngModelChange)="checkpopup('taxonomyCode')">
                          </div>
                        </div>
                      </div>
                      <div class="row pl-3">
                        <label class="label-bold"> Facility Requirements(Leave Blank for Homecare)</label>
                      </div>
                      <div class="row">
                        <div class="col pl-3">
                          <div class="row mt-2">
                            <label class="pl-3 col-md-4 col-sm-4 label-bold">Name</label>
                            <input type="text" class="form-control col-lg-4" formControlName="name"
                              [(ngModel)]="GroupPayorService.name" (ngModelChange)="checkpopup('name')" id="CreateGpFName" >
                          </div>
                          <div class="row mt-2">
                            <label class="pl-3  col-md-4 col-sm-4 label-bold">Address</label>
                            <input type="text" class="form-control col-lg-4" formControlName="address1"
                              [(ngModel)]="GroupPayorService.address1" (ngModelChange)="checkpopup('address1')" id="CreateGpFAddress1">
                          </div>
                          <div class="row mt-2">
                            <label class="pl-3  col-md-4 col-sm-4 pr-0 label-bold">Address 2</label>
                            <input type="text" class="form-control col-lg-4" formControlName="address2"  id="CreateGpFAddress2"
                              [(ngModel)]="GroupPayorService.address2" (ngModelChange)="checkpopup('address2')">
                          </div>
                          <div class="row mt-2">
                            <label class="pl-3  col-md-4 col-sm-4 label-bold">City</label>
                            <input type="text" class="form-control col-lg-4" formControlName="city"  id="CreateGpFCity"
                              [(ngModel)]="GroupPayorService.city" (ngModelChange)="checkpopup('city')">
                          </div>
                          <div class="row mt-2">
  
                            <label class="pl-3  col-md-4 col-sm-4 label-bold"> State</label>
  
  
                            <ng-select [items]="stateList" [searchable]="true" [clearable]="true" class=" col-lg-4"  id="CreateGpState"
                              bindLabel="name" bindValue="abbreviation" formControlName="state" [selectOnTab]="true"
                              [(ngModel)]="GroupPayorService.state" (ngModelChange)="checkpopup('state')">
                            </ng-select>
  
                          </div>
                          <div class="row mt-2">
                            <label class="pl-3  col-sm-4 label-bold">Zip</label>
                            <input type="text" class="form-control col-lg-4" maxlength="10" formControlName="zipCode"
                              [(ngModel)]="GroupPayorService.zipCode" (ngModelChange)="checkpopup('zipCode')"  id="CreateGpZip">
                            <button class="btn blue-btn btn-sm btn-height ml-2 mt-1" type="button" (click)="getzipcode()"
                              [disabled]="GroupPayorService.city==null || GroupPayorService.city==undefined || GroupPayorService.city==''|| GroupPayorService.state==null||GroupPayorService.state==undefined ||GroupPayorService.state=='' || GroupPayorService.address1==null || GroupPayorService.address1==undefined || GroupPayorService.address1==''">Get
                              Zip</button>
                          </div>
                          <div class="row mt-2">
                            <label class="pl-3  col-sm-4 label-bold">ID</label>
                            <input type="text" class="form-control col-lg-4" formControlName="facilityID"  id="CreateGpId"
                              [(ngModel)]="GroupPayorService.facilityID" (ngModelChange)="checkpopup('facilityID')">
                          </div>
                          <div class="row mt-2">
                            <label class="pl-3  col-sm-4 label-bold">ServiceLoc<sup
                                class="super-script">&nbsp;*</sup></label>
  
                            <input type="text" class="form-control col-lg-4" formControlName="serviceLoc"
                              [(ngModel)]="GroupPayorService.serviceLoc" (ngModelChange)="checkpopup('serviceLoc')" id="CreateGpServiceLoc">
                            <span class="help-block text-danger text-center"
                              *ngIf="!groupPayerForm.get('serviceLoc').valid && groupPayerForm.get('serviceLoc').touched ">
                              <p>Please Enter Location</p>
                            </span>
                          </div>
                          <div class="row">
                            <div class="col-lg-4 col-md-4 col-sm-6 col-xs-6 pl-0 pr-0 ml-3">
                              <input type="checkbox" id="pharm" formControlName="pharm" id="CreateGppharm"
                                (ngModelChange)="checkpopup('pharm')" [(ngModel)]="GroupPayorService.pharm">&nbsp;
                              <label for="pharm" class="label-bold">Pharm</label>
                            </div>
                            <div class="col-lg-4 col-md-4 col-sm-6 col-xs-6 pl-0 pr-0 ml-3">
                              <input type="checkbox" id="hme" formControlName="homeVisit"  id="CreateGphomeVisit"
                                (ngModelChange)="checkpopup('homeVisit')" [(ngModel)]="GroupPayorService.homeVisit">&nbsp;
                              <label for="hme" class="label-bold">Home Visit</label>
                            </div>
                            <div class="col-lg-4 col-md-4 col-sm-6 col-xs-6 pl-0 pr-0 ml-3">
                              <input type="checkbox" id="wvf" formControlName="waiverFlag"
                                (ngModelChange)="checkpopup('waiverFlag')" id="CreateGpWaiverflag"
                                [(ngModel)]="GroupPayorService.waiverFlag">&nbsp;
                              <label for="wvf" class="label-bold">Waiver flag</label>
                            </div>
                            <div class="col-lg-4 col-md-4 col-sm-6 col-xs-6 pl-0 pr-0 ml-3">
                              <input type="checkbox" id="comClaim" formControlName="combineClaim"
                                (ngModelChange)="checkpopup('combineClaim')"
                                [(ngModel)]="GroupPayorService.combineClaim"  id="CreateGpCombineClaim">&nbsp;
                              <label for="comClaim" class="label-bold">Combine Claim</label>
                            </div>
                            <div class="col-lg-4 col-md-4 col-sm-6 col-xs-6 pl-0 pr-0 ml-3">
                              <input type="checkbox" id="comClaim" formControlName="atypical" id="CreateGpatypical"
                                (ngModelChange)="checkpopup('atypical')" [(ngModel)]="GroupPayorService.atypical">&nbsp;
                              <label for="comClaim" class="label-bold">Atypical</label>
                            </div>
                            <div class="col-lg-4 col-md-4 col-sm-6 col-xs-6 pl-0 pr-0 ml-3">
                              <input type="checkbox" id="comClaim" formControlName="umpiPayorUMPIMust" id="CreateGpumpiPayorUMPIMust"
                                (ngModelChange)="checkpopup('umpiPayorUMPIMust')"
                                [(ngModel)]="GroupPayorService.umpiPayorUMPIMust">&nbsp;
                              <label for="comClaim" class="label-bold">PayorID and UMPI</label>
                            </div>
                            <div class="col-lg-4 col-md-4 col-sm-6 col-xs-6 pl-0 pr-0 ml-3">
                              <input type="checkbox" id="sprProvider" formControlName="supervisingProvider"
                                (ngModelChange)="checkpopup('supervisingProvider')"
                                [(ngModel)]="GroupPayorService.supervisingProvider">&nbsp;
                              <label for="sprProvider" class="label-bold">Supervising Provider</label>
                            </div>
                            <div class="col-lg-4 col-md-4 col-sm-6 col-xs-6 pl-0 pr-0 ml-3">
                              <input type="checkbox" id="referProivder" formControlName="referringProvider"
                                (ngModelChange)="checkpopup('referringProvider')"
                                [(ngModel)]="GroupPayorService.referringProvider">&nbsp;
                              <label for="referProivder" class="label-bold">Referring Provider</label>
                            </div>
                            <div class="col-lg-4 col-md-4 col-sm-6 col-xs-6 pl-0 pr-0 ml-3">
                              <input type="checkbox" id="claimAttach" formControlName="claimAttachment"
                                (ngModelChange)="checkpopup('claimAttachment')"
                                [(ngModel)]="GroupPayorService.claimAttachment">&nbsp;
                              <label for="claimAttach" class="label-bold">Claim Attachment</label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row mt-4">
  
                    <div class="col-lg-2">
                      <div class="row">
  
                        <label class="label-bold ml-2 mb-2">Rate Change Date</label>
  
                        <my-date-picker class="col-lg-12" [options]="myDatePickerOptions" id="CreateGpRCD"
                          [selDate]="GroupPayorService.rateChangeDate" placeholder="mm/dd/yyyy"
                          (inputFieldChanged)="newdates($event,'inputchage','rateChangeDate')"
                          (dateChanged)="newdates($event,'datechagned','rateChangeDate')">
                        </my-date-picker>
                      </div>
                    </div>
                    <div class="col-lg-2  ml-2 mb-2">
                      <div class="row  aligned_form">
                        <label class="label-bold">CallTypeID</label>
                        <input type="number" class="form-control" formControlName="callTypeID" id="CreateGpCallTypeID"
                          [(ngModel)]="GroupPayorService.callTypeID" (ngModelChange)="checkpopup('callTypeID')">
                      </div>
                    </div>
                    <div class="col-lg-2  ml-2  mb-2">
                      <div class="row  aligned_form">
                        <label class="label-bold">Unit Multiplier</label>
                        <input type="number" class="form-control" formControlName="unitMultiplier" id="CreateGpunitMultiplier"
                          [(ngModel)]="GroupPayorService.unitMultiplier" (ngModelChange)="checkpopup('unitMultiplier')">
                      </div>
                    </div>
  
                    <div class="col-lg-2  ml-2 mb-2">
                      <div class="row  aligned_form">
                        <label class="label-bold">Old U/C Rate</label>
                        <input type="number" class="form-control" formControlName="oldUCRate" id="CreateGpoldUCRate"
                          [(ngModel)]="GroupPayorService.oldUCRate" (ngModelChange)="checkpopup('oldUCRate')">
                      </div>
                    </div>
                    <div class="col-lg-2  ml-2 mb-2">
                      <div class="row  aligned_form">
                        <label class="label-bold">Old Net Rate</label>
                        <input type="number" class="form-control" formControlName="oldNetRate" id="CreateGpoldNetRate"
                          [(ngModel)]="GroupPayorService.oldNetRate" (ngModelChange)="checkpopup('oldNetRate')">
                      </div>
                    </div>
  
                  </div>&nbsp;&nbsp;&nbsp;
  
  
  
                </div>
  
              </div>
            </form>
          </div>
  
        </div>
      </div>
    </div>
  
  </div>
  </div>
  <!-- Close Modal -->
  <span id="openModal1" data-bs-target="#CloseModal" data-bs-toggle="modal"></span>
  <div class="modal" id="CloseModal" data-bs-backdrop="static">
    <div class="modal-dialog modal-sm">
      <div class="modal-content">
  
        <!-- Modal Header -->
        <div class="modal-header">
          <h4 class="modal-title">Close</h4>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
            <span aria-hidden="true"></span>
          </button>
  
        </div>
  
        <!-- Modal body -->
        <div class="modal-body">
          You want to close without save?
        </div>
  
        <!-- Modal footer -->
        <div class="modal-footer">
          <button type="button" class="btn blue-btn" (click)="cancelYes()">Yes</button>
          <button type="button" class="btn blue-btn" data-bs-dismiss="modal">No</button>
        </div>
  
      </div>
    </div>
  </div>
  
  <!-- Delete Modal -->
  <span id="openModal2" data-bs-target="#deletemodal" data-bs-toggle="modal"></span>
  <div class="modal fade" id="deletemodal" data-bs-backdrop="static">
    <div class="modal-dialog delete-zip" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5>Delete Record</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
            <span aria-hidden="true"></span>
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-lg-12">
              <label>Do you want to delete this record ?</label>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn blue-btn btn-sm"
            (click)="DeleteGroupPayorServiceTable();deleteDetails(GroupPayorService.id)">Delete</button>
          <button type="button" class="btn blue-btn btn-sm" data-bs-dismiss="modal">Cancel</button>
        </div>
      </div>
    </div>
  </div>
  
  <span id="openservicerateModal" data-bs-toggle="modal" data-bs-target="#UpdateServicerate"></span>
  <div class="modal fade" id="UpdateServicerate" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title font-header" id="exampleModalLabel">
            <span>Update Rates</span>
          </h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
            <span aria-hidden="true"></span>
          </button>
        </div>
        <div class="modal-body">
          <div class="row mt-2">
            <div class="col-lg-4">
              <label class="label-bold">Service Code<sup class="super-script">&nbsp;*</sup></label>
            </div>
            <div class="col-lg-8">
              <ng-select [(ngModel)]="updateRatesInBulk.masterServiceId" [searchable]="true" [clearable]="true"
                [items]="Allservice" class="tdropdown" bindLabel="masterservice"
                 bindValue="id"
                (change)="checkpopup('Service')" groupBy="type">
                <ng-template ng-optgroup-tmp let-item="item">
                  {{item.type}}
                </ng-template>
              </ng-select>
            </div>
          </div>
  
         <div class="row mt-2">
            <div class="col-lg-4">
              <label class="label-bold">Net Rate<sup class="super-script">&nbsp;*</sup></label>
            </div>
            <div class="col-lg-8">
              <input type="number" class="form-control" [(ngModel)]="updateRatesInBulk.netRate"
            >
            </div>
          </div>
          <div class="row mt-2">
            <div class="col-lg-4">
              <label class="label-bold">U/C Rate<sup class="super-script">&nbsp;*</sup></label>
            </div>
            <div class="col-lg-8">
              <input type="number" class="form-control" [(ngModel)]="updateRatesInBulk.unitrate"
               >
            </div>
          </div>
      <div class="row mt-4">
        <div class="col-lg-4">
          <label class="label-bold">Start Date<sup class="super-script">&nbsp;*</sup></label>
        </div>
        <div class="col-lg-8">
            <my-date-picker class="w-100" [options]="myDatePickerOptions"
              [selDate]="updateRatesInBulk.rateChangeDate" placeholder="mm/dd/yyyy"
              (inputFieldChanged)="newdates($event,'inputchage','startDate')"
              (dateChanged)="newdates($event,'datechagned','startDate')">
            </my-date-picker>
        </div>
      </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn blue-btn btn-sm" (click)="updateSeerviceRate()" [disabled]="updateRatesInBulk.masterServiceId=='00000000-0000-0000-0000-000000000000'||updateRatesInBulk.masterServiceId==undefined||updateRatesInBulk.masterServiceId==null||updateRatesInBulk.rateChangeDate==null||updateRatesInBulk.rateChangeDate==undefined||updateRatesInBulk.rateChangeDate==''
          ||updateRatesInBulk.netRate==0||updateRatesInBulk.netRate==undefined||updateRatesInBulk.netRate==null||updateRatesInBulk.unitrate==0||updateRatesInBulk.unitrate==undefined||updateRatesInBulk.unitrate==null" >Save</button>
          <button type="button" class="btn blue-btn btn-sm" data-bs-dismiss="modal">Close</button>
        </div>
      </div>
    </div>
  </div>
  
  